export default __webpack_public_path__ + "static/media/1.b0c41511.png";